import {Check} from '@sparkware/app-utils';
import {GameInfo} from '../games/game-info';
import {IGameFilter, FilterType} from '../games-filter/filters/game-filter.interface';
import {IAbFilterData} from './ab-filtering.service.interface';
import {IServiceFactory} from '../service-factory.interface';
import {IAbFilteringStrategy} from './ab-filtering-strategy.interface';

export class AbFilteringStrategy implements IAbFilteringStrategy {

  private _services: IServiceFactory;
  private _logMessage: string = ``;

  private _filter: IGameFilter = {
    filterType: FilterType.featureFilter,
    applyFilter: (gameInfo: GameInfo, currentFilters: []) => false
  };  
  
  public abFilterData: IAbFilterData;

  constructor(abFilterData: IAbFilterData, services: IServiceFactory) {
    
    this._services = services;

    if (Check.isNullOrUndefined(abFilterData) || Check.isNullOrUndefined(abFilterData.filterBy)) {
      this._services.logger.warning(`Trying to create an AB Filtering Strategy with an invalid AB Filter Data! ${JSON.stringify(abFilterData)}`);
    }
    
    abFilterData = abFilterData || {filterBy: {}};
    abFilterData.filterBy = abFilterData.filterBy || {};

    const filterType = Object.keys(abFilterData.filterBy)[0];
    const filterValue = abFilterData.filterBy[filterType];
    const filter = services.gamesFilter.tryCreateFilter(filterType, filterValue);

    if (filter) {
      this._filter = filter;
    }

    this.abFilterData = abFilterData;

    this._logMessage = `AB Filtering | Filter out games by ${JSON.stringify(this.abFilterData.filterBy)} from the ${this.abFilterData.listKey ? `list "${this.abFilterData.listKey}"` : `arena "${this.abFilterData.arenaId}"`}.`;
  }

  public applyFiltering(gameTypes: number[]): number[] {

    this._services.logger.info(this._logMessage);

    return gameTypes.filter((gameType) => {

      const gameInfo: GameInfo = this._services.gamesFilter.filteredGamesMap[gameType];

      if (Check.isNullOrUndefined(gameInfo)) {
        return false;

      } else {
        // Negate the filter logic for the exclusive behaviour
        return !this._filter.applyFilter(gameInfo, []);
      }
    });
  }
}
